import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App.jsx';
import { GlobalProvider } from './utils/globalContext.js';
import { ApolloClient, ApolloProvider, InMemoryCache, HttpLink } from '@apollo/client';
import { apiBasePath } from './utils/constants';

const client = new ApolloClient({
  link: new HttpLink({
    uri: `${apiBasePath}/graphql`
  }),
  cache: new InMemoryCache()
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <GlobalProvider>
        <App />
      </GlobalProvider>
    </ApolloProvider>
  </React.StrictMode>
);
